import React from "react";
import { fileImageUrl } from "../lib/api";

export default function Avatar({ profile, size = 48, ring = false }) {
  if (!profile) {
    return (
      <div
        className="rounded-full bg-zinc-800 border border-white/10"
        style={{ width: size, height: size }}
      />
    );
  }
  const bg = profile.avatar_color || "#ff3b1d";
  const initial = (profile.name || "?").trim().charAt(0).toUpperCase();
  const fontSize = Math.max(12, Math.floor(size * 0.45));

  const common = {
    width: size,
    height: size,
    fontSize,
  };

  return (
    <div
      className={`rounded-full overflow-hidden flex items-center justify-center font-display uppercase ${
        ring ? "ring-2 ring-[color:var(--ns-accent)] ring-offset-2 ring-offset-black" : ""
      }`}
      style={{ ...common, background: profile.avatar_url ? "transparent" : bg }}
    >
      {profile.avatar_url ? (
        <img
          src={fileImageUrl(profile.avatar_url)}
          alt={profile.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <span className="text-white font-bold leading-none select-none">{initial}</span>
      )}
    </div>
  );
}
